import React from 'react';

interface ListFilterProps {
  filter: any;
  isActive: boolean;
  onChange: () => void;
}

const ListFilter = ({ filter, isActive, onChange }: ListFilterProps) => (
  <div className={`listFilters__borderedFilter ${isActive ? 'active' : ''}`} onClick={onChange}>
    {filter.title}: {filter.value}
  </div>
);

interface ListFilterGroupProps {
  activated?: string;
  filterGroup: any;
  onChange: (filterKey: any) => void;
}

const ListFilterGroup = ({ activated, filterGroup, onChange }: ListFilterGroupProps) => (
  <div className="listFilters__group">
    <div className="listFilters__groupTitle">{filterGroup.title}</div>
    <div className="listFilters__groupFiltersContainer">
      {Object.keys(filterGroup.filters).map((key: string) => (
        <ListFilter
          filter={filterGroup.filters[key]}
          isActive={activated === key}
          key={key}
          onChange={() => onChange(key)}
        />
      ))}
    </div>
  </div>
);

interface ListFiltersProps {
  filterActivated?: string;
  filtersGroups?: any;
  onChange?: (activated: boolean) => void;
}

interface ListFiltersState {
  activated: any;
}

class ListFilters extends React.Component<ListFiltersProps> {
  public static defaultProps = {
    filtersGroups: [],
    onChange: () => {
      // nothing
    },
  };

  public state: ListFiltersState = {
    activated: undefined,
  };

  public componentDidMount() {
    // const { onChange } = this.props;
    // onChange(this.state.activated);
  }

  public render() {
    const {
      filterActivated,
      filtersGroups,
      onChange,
    } = this.props;

    return (
      <div className="listFilters__container">
        {Object.keys(filtersGroups).map(key => {
          const filterGroup = filtersGroups[key];

          if (filterGroup.disabled) {
            return <React.Fragment key={key} />;
          }

          return (
            <ListFilterGroup
              activated={filterActivated}
              filterGroup={filterGroup}
              key={key}
              onChange={filterKey => {
                this.setState(
                  (currentState: ListFiltersState) => ({
                    activated: currentState.activated !== filterKey ? filterKey : undefined,
                  }),
                  () => {
                    if (onChange) onChange(this.state.activated);
                  }
                );
              }}
              // activated={filterActivated || this.state.activated}
            />
          );
        })}
      </div>
    );
  }
}

export default ListFilters;
